import { Typography } from '@mui/material';
import bigInt from 'big-integer';
import React, { Fragment, PureComponent } from 'react';
import CountUp from 'react-countup';

import {
  bigIntegerToLocaleString,
  humanFormatBigInteger,
} from 'shared/utils/bigInteger';

interface CountProps {
  value: string | number | bigInt.BigInteger;
  animated?: boolean;
  animationStart: number;
  animationDelay: number;
  humanize?: boolean;
  suffix?: string;
  suffixPadding?: boolean;
  className?: any;
  title?: string;
}

export class Count extends PureComponent<CountProps> {
  static defaultProps: Partial<CountProps> = {
    animationStart: 0,
    animationDelay: 0,
    suffix: '',
    suffixPadding: true,
    humanize: true,
  };

  // complexity 12
  // eslint-disable-next-line complexity
  render() {
    const {
      value,
      animated,
      animationStart,
      animationDelay,
      humanize,
      suffix: _,
      suffixPadding,
      ...rest
    } = this.props;
    let suffix = this.props.suffix;

    let bigIntVal;
    if (bigInt.isInstance(value)) {
      bigIntVal = value;
    } else {
      const parsed = parseInt(value as string).toString();
      bigIntVal = value ? bigInt(parsed) : bigInt.zero;
    }
    const isBigInt = bigIntVal.greater(999);
    let formattedVal = isBigInt
      ? humanFormatBigInteger(bigIntVal)
      : bigIntegerToLocaleString(bigIntVal);
    const title = bigIntegerToLocaleString(bigIntVal);

    if (humanize) {
      // Parse out the number and suffix, example: '12.5 M'
      if (isBigInt) {
        const [num, suf] = formattedVal.split(' ');
        formattedVal = num;
        suffix = suffixPadding ? ` ${suf} ${suffix}` : `${suf}${suffix}`;
      }
    } else if (animated) {
      // Need to remove the `,` to pass it to count up
      formattedVal = title.replace(',', '');
    }

    return (
      <Typography
        component='span'
        fontSize='inherit'
        lineHeight='inherit'
        title={title}
        color='inherit'
        {...rest}
      >
        {animated && value && (
          <CountUp
            delay={animationDelay}
            duration={1}
            end={Number(formattedVal)}
            key={value as string}
            start={animationStart}
            suffix={suffix}
          />
        )}
        {!animated && (
          <Fragment>
            {formattedVal} {suffix}
          </Fragment>
        )}
      </Typography>
    );
  }
}
